import { render } from "./CreditsComponent.vue?vue&type=template&id=254c6a06&scoped=true"
import script from "./CreditsComponent.vue?vue&type=script&lang=js"
export * from "./CreditsComponent.vue?vue&type=script&lang=js"

import "./CreditsComponent.vue?vue&type=style&index=0&id=254c6a06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254c6a06"]])

export default __exports__